<input type="file" (change)="onImportFile($event)" #fileInput hidden accept=".csv, .xlsx, .xls" />
@if (importMode === 'import') {
<div class="import-dialog">
  <div class="import-dialog__header">
    <h3 class="import-dialog__title">Import Items</h3>
    <button
      type="button"
      class="import-dialog__close p-button-text p-button-rounded"
      pButton
      icon="pi pi-times"
      (click)="onCloseDialog()"
      aria-label="Close"
    ></button>
  </div>
  <div class="import-dialog__body">
    <p class="import-dialog__formats">Supported formats: CSV, Excel</p>
    <div class="import-dialog__radio-group">
      <div class="import-dialog__radio-option">
        <p-radioButton inputId="importAllItems" name="exportNodeSelection" value="allnode" [(ngModel)]="exportNodeSelection"></p-radioButton>
        <label for="importAllItems">All Items</label>
      </div>
      <div class="import-dialog__radio-option">
        <p-radioButton
          inputId="importTestItems"
          name="exportNodeSelection"
          value="testnodeonly"
          [(ngModel)]="exportNodeSelection"
        ></p-radioButton>
        <label for="importTestItems">Test items with test steps</label>
      </div>
    </div>
  </div>
  <div class="dialog-footer">
    <button pButton type="button" label="Cancel" class="p-button-text" (click)="onCloseDialog()"></button>
    <button pButton type="button" label="Import" class="admin-primary-btn" (click)="onImport()"></button>
  </div>
</div>
} @if (importMode === 'importing_failed') {
<div class="import-dialog import-dialog--compact">
  <div class="import-dialog__header">
    <h3 class="import-dialog__title">Import Failed!</h3>
  </div>
  <div class="import-dialog__message">Import action failed! Please checks logs for more details</div>
  <div class="dialog-footer">
    <button pButton type="button" label="Ok" class="admin-primary-btn" (click)="onCloseDialog()"></button>
  </div>
</div>
} @if (importMode === 'importing_success') {
<div class="import-dialog import-dialog--compact">
  <div class="import-dialog__header">
    <h3 class="import-dialog__title">Import Complete</h3>
  </div>
  <div class="import-dialog__message">Imported items successfully!</div>
  <div class="dialog-footer">
    <button pButton type="button" label="Ok" class="admin-primary-btn" (click)="onCloseDialog()"></button>
  </div>
</div>
} @if (importMode === 'importing') {
<div class="import-dialog import-dialog--compact">
  <div class="import-dialog__header">
    <h3 class="import-dialog__title">Importing...</h3>
  </div>
  <mat-progress-bar [mode]="completed > 0 ? 'determinate' : 'indeterminate'" [value]="progressValue"> </mat-progress-bar>
  <p class="import-dialog__progress-text">{{ completed }} / {{ total }} imported</p>
</div>
}
